import React from 'react'

import { Grid, ButtonBase, Typography, makeStyles, useTheme } from '@material-ui/core'
import { LocationOn } from '@material-ui/icons'

import track from '~/track'
import { useLiterals } from '~/components/Literals'
import { usePositionHandler } from '~/containers/PositionHandler'
import { useIsInIframe } from '../useIsInIframe'
import useViewportSize from '~/components/useViewportSize'

const useStyle = makeStyles((theme) => ({
  customerLocationBar: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    background: '#F5F5F5',
    fontSize: '12px',
    padding: '8px 16px',
  },
  textLocation: {
    display: 'flex',
    alignItems: 'center',
  },
  iconColor: {
    color: theme.palette.primary.light,
  },
}))

function PositionLabel({ position }) {
  const { getLiteral } = useLiterals()

  let address = null

  if (Object.values(position?.user || {}).some(Boolean)) {
    const { street, city, state, description } = position.user

    address = description || `${street?.concat(', ') || ''} ${city?.concat(' - ') || ''}${state || ''}`
  } else {
    address = <span>{getLiteral('2613')}</span>
  }

  return address || <span style={{ display: 'none' }} />
}

const PositionButton = ({ resselButtonComponent = null }) => {
  const isInIframe = useIsInIframe()
  const classes = useStyle()
  const theme = useTheme()
  const viewport = useViewportSize()
  const { getLiteral } = useLiterals()

  const position = usePositionHandler()

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const handleChangeLocation = () => {
    position.handlerShowPositionDialog(true)
    track('alterarLocalização', {
      category: 'menu',
      name: `${position.user?.city} - ${position.user?.state}`,
    })
  }

  return (
    <Grid id="user-position-location" className={classes.customerLocationBar}>
      <Typography
        noWrap
        data-cy="current-city"
        component={ButtonBase}
        className={classes.textLocation}
        onClick={handleChangeLocation}
      >
        {position.user && <span style={{ fontSize: '14px' }}>{getLiteral('2398')}:</span>}
        <LocationOn
          className={classes.iconColor}
          style={{
            fontSize: '12px',
            margin: '0 5px -3px',
          }}
        />
        <span
          style={{
            textDecoration: 'underline',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          datalayer_location_state={
            position?.user?.state?.length > 2 ? position.user?.stateCode : position?.user?.state
          }
          datalayer_location_city={position?.user?.city}
        >
          <PositionLabel position={position} />
        </span>
      </Typography>
      {(isInIframe || isMobile) && <Grid style={{ flexShrink: 0 }}>{resselButtonComponent}</Grid>}
    </Grid>
  )
}

export default PositionButton
